import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import Modal from "../base-modal.jsx";
import {getCookie} from "../../utils";
import {
    LDP_METRICS_OTHER_PAGE,
    LDP_METRICS_PROFILE_PAGE,
    LDP_METRICS_RETAILER_CLASSNAME,
    LDP_METRICS_SMS_SEND_ACTION,
    LDP_METRICS_STORE_CLASSNAME,
    LDP_METRICS_STORE_LOCATOR_PAGE,
    LDP_METRICS_TRY_THIS_BED_PAGE
} from "../../constants.js";

import {ldpMetricsAction} from "../../utils.js";
import DataLayerService from "datalayer-service/src/datalayer";
import {QualifyingEventAction} from "datalayer-service/src/types/enums";

const MODAL_ID = "send-text-modal";
const NAME_FIELD = "name";
const MOBILE_FIELD = "primary_phone";
const MOBILE_MAX_LENGTH = 17;
const MESSAGE_FIELD = "message";
const MESSAGE_MAX_LENGTH = 300;
const phoneRegExp = /^(\+1[ ])?\(?([0-9]{3})\)?[ ]?([0-9]{3})[-]?([0-9]{4})$/;
const ENDPOINT = "/api/v1/partners/retailer-inquiry/create/";

const dataLayerService = new DataLayerService(window);
export function renderModal(data) {
    const element = document.getElementById(MODAL_ID);

    if (data) {
        let props = {
            retailerID: data.retailerID,
            storeSlug: data.storeSlug,
            storeName: data.storeName,
            locationPage: data.locationPage,
            objectClassname: data.objectClassname,
            isQuickView: data.isQuickView,
        };

        if (data.storeID) props.storeID = data.storeID;

        ReactDOM.render(<SendTextModal {...props} />, element);
    }
}

class SendTextModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            success: false,
            submitted: false,
            showErrors: false,
            messageLength: MESSAGE_MAX_LENGTH,
            fields: {
                [NAME_FIELD]: {
                    valid: false,
                    touched: false,
                    value: "",
                    error: "",
                    min: 1,
                    max: 50,
                },
                [MOBILE_FIELD]: {
                    valid: false,
                    touched: false,
                    value: "",
                    error: "",
                    min: 14, // with parenthesis, dash and space
                    max: MOBILE_MAX_LENGTH,
                },
                [MESSAGE_FIELD]: {
                    valid: false,
                    touched: false,
                    value: "",
                    error: "",
                    min: 10,
                    max: 300,
                },
            },
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.validateFields = this.validateFields.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.renderFieldStatusIcon = this.renderFieldStatusIcon.bind(this);
        this.errorMessage = this.errorMessage.bind(this);
        this.renderHeader = this.renderHeader.bind(this);
        this.renderSuccess = this.renderSuccess.bind(this);
        this.renderBody = this.renderBody.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
    }

    handleCloseModal() {
        const { storeSlug, isQuickView } = this.props;

        if (isQuickView) {
            const storeModalID = `${storeSlug}-store-qv`;
            // // Check if modal exist
            const element = document.getElementById(storeModalID);
            // // Show store quick view modal
            if (storeSlug && element) $(`#${storeModalID}`).modal("show");
            // // Hide scroll when the quick view modal is open
            $("body").css({ "overflow-y": "hidden" });
            // When store quick view modal is hidden, show the page scroll bar.
            if (storeSlug && element)
                $(`#${storeModalID}`).on("hidden.bs.modal", () => {
                    $("body").css({ "overflow-y": "auto" });
                });
            else $("body").css({ "overflow-y": "auto" });
        }

        // Unmount the send text modal component.
        ReactDOM.unmountComponentAtNode(document.getElementById(MODAL_ID));
    }

    handleSubmit(e) {
        const { retailerID, storeID, storeSlug, locationPage, objectClassname } = this.props;
        const { fields } = this.state;

        this.validateFields();

        if (!this.isFormValid(fields)) {
            this.setState({
                showErrors: true
            })

            e.preventDefault();
            return
        };

        const data = {
            retailer: parseInt(retailerID),
            [NAME_FIELD]: fields[NAME_FIELD].value,
            [MOBILE_FIELD]: fields[MOBILE_FIELD].value,
            [MESSAGE_FIELD]: fields[MESSAGE_FIELD].value,
        };

        if (storeID) data.store = parseInt(storeID);

        e.preventDefault();

        $.ajax({
            url: ENDPOINT,
            method: "POST",
            headers: {"X-CSRFToken": getCookie("csrftoken")},
            data,
        })
            .done((rs) => {
                ldpMetricsAction(locationPage, LDP_METRICS_SMS_SEND_ACTION, storeSlug, objectClassname);
                this.setState({success: true, submitted: true});

                if (rs.member) {
                  dataLayerService.qualifyingActionEvent({
                    action: QualifyingEventAction.RETAILER_INQUIRY,
                    memberId: rs.member.member_id,
                    authLevel: rs.member.auth_level,
                    userType: rs.member.user_type,
                  })
                }
            })
            .fail(() => {
                this.setState({success: false, submitted: true});
            });
    }

    formatPhoneNumber(value) {
        let phoneNumber = value.replace(/\D+/g, "");
        const size = phoneNumber.length;
        const startsWithPrefix = phoneNumber.startsWith("1");

        if (startsWithPrefix) {
            if (size > 0) phoneNumber = `+${phoneNumber}`;
            if (size > 1)
                phoneNumber = `${phoneNumber.slice(0, 2)} (${phoneNumber.slice(
                    2,
                    16
                )}`;
            if (size > 4)
                phoneNumber = `${phoneNumber.slice(0, 7)}) ${phoneNumber.slice(
                    7,
                    16
                )}`;
            if (size > 7)
                phoneNumber = `${phoneNumber.slice(0, 12)}-${phoneNumber.slice(
                    12
                )}`;
        } else {
            if (size > 0) phoneNumber = `(${phoneNumber}`;
            if (size > 3)
                phoneNumber = `${phoneNumber.slice(0, 4)}) ${phoneNumber.slice(
                    4,
                    11
                )}`;
            if (size > 6)
                phoneNumber = `${phoneNumber.slice(0, 9)}-${phoneNumber.slice(
                    9
                )}`;
        }

        return phoneNumber;
    }

    isFormDirty(fields) {
        for (const key in fields) {
            if (fields.hasOwnProperty(key) && fields[key].value.length !== 0)
                return true;
        }

        return false;
    }

    isFormValid(fields) {
        for (const key in fields) {
            if (fields.hasOwnProperty(key) && !fields[key].valid) return false;
        }

        return true;
    }

    validate(field, fieldName, value) {
        let error = "";
        const name = fieldName === MOBILE_FIELD ? "Phone number" : fieldName;

        if (value.length === 0) error = `${name} is required`;
        else if (value.length < field.min) error = `${name} is too short`;
        else if (value.length > field.max) error = `${name} is too long`;
        else if (value.length >= field.min && fieldName === MOBILE_FIELD) {
            const regex = new RegExp(phoneRegExp);

            if (!regex.test(value)) error = "Phone number is not valid";
        }

        return {
            error: error,
            valid: error.length === 0,
        };
    }

    validateFields() {
        const { fields } = this.state;

        let validatedFields = {...fields}

        for ( const field in fields) {
            const { error, valid } = this.validate(fields[field], field, fields[field].value);

            validatedFields[field].error = error;
            validatedFields[field].valid = valid;
        }

        this.setState({ fields: validatedFields })
    }

    handleBlur(e) {
        const { fields } = this.state;
        const name = e.target.name;
        let value = e.target.value;

        if (!fields[name].touched) {
            this.setState({
                fields: {
                    ...fields,
                    [name]: {
                        ...fields[name],
                        touched: true,
                        ...this.validate(fields[name], name, value),
                    },
                },
            });
        }
    }

    handleChange(e) {
        const { fields } = this.state;
        const name = e.target.name;
        let value = e.target.value;
        if (name === MOBILE_FIELD) value = this.formatPhoneNumber(value);

        let newState = {
            fields: {
                ...fields,
                [name]: {
                    ...fields[name],
                    value: value,
                    touched: true,
                    ...this.validate(fields[name], name, value),
                },
            },
        };

        if (name === MESSAGE_FIELD)
            newState = {
                ...newState,
                messageLength: MESSAGE_MAX_LENGTH - value.length,
            };

        this.setState(newState);
    }

    errorMessage(fieldName) {
        const { showErrors, fields } = this.state;

        if (!showErrors) return;

        return !fields[fieldName].valid ? (
            <div className="error-message">{fields[fieldName].error}</div>
        ) : null;
    }

    renderFieldStatusIcon(fieldName) {
        const { fields, showErrors } = this.state;

        return fields[fieldName].valid ? (
            <i className="input-icon is-valid fa fa-check" />
        ) : showErrors && (
            <i className="input-icon has-error fa fa-times" />
        );
    }

    renderHeader() {
        const { storeName } = this.props;
        const { success, submitted } = this.state;

        return (
            <div style={{ width: "100%", textAlign: "center" }}>
                {!success && !submitted && (
                    <>
                        <h4>Have a question?</h4>
                        <div className="sub-header">
                            Get the answer straight to your phone.
                        </div>
                    </>
                )}
                {success && submitted && <h4>Thank you for your message.</h4>}
                {!success && submitted > 0 && (
                    <h4>Sorry, there was an error!</h4>
                )}
            </div>
        );
    }

    renderForm() {
        const { storeName } = this.props;
        const { messageLength, fields } = this.state;

        return (
            <>
                <div className="chat-bubble small">
                    An expert from
                    {' '}
                    {storeName}
                    {' '}
                    will reply to your question ASAP.
                </div>
                <div className="chat-bubble-container">
                    <div className="chat-bubble large">

                    <label htmlFor={MESSAGE_FIELD}>Your Question</label>
                        <div className="input-group hide-placeholder-on-focus">
                            <textarea
                                name={MESSAGE_FIELD}
                                placeholder="Do you have this bed in your store? How soon can you deliver? Etc."
                                rows={3}
                                value={fields[MESSAGE_FIELD].value}
                                maxLength={MESSAGE_MAX_LENGTH}
                                onBlur={this.handleBlur}
                                onChange={this.handleChange}
                                className="message-textarea"
                            />
                            <div className="input-group-append">
                                {this.renderFieldStatusIcon(MESSAGE_FIELD)}
                            </div>
                        </div>
                        {this.errorMessage(MESSAGE_FIELD)}
                        {fields[MESSAGE_FIELD].touched &&
                            fields[MESSAGE_FIELD].valid && (
                                <div className="message-remaining-chars">
                                    <b>{messageLength}</b>
                                    {messageLength !== 1
                                        ? "characters"
                                        : "character"}{" "}
                                    left
                                </div>
                            )
                        }

                        <label htmlFor={MOBILE_FIELD}>Mobile Phone</label>
                        <div className="input-group">
                            <input
                                type="text"
                                name={MOBILE_FIELD}
                                placeholder="(313) 555-1212"
                                value={fields[MOBILE_FIELD].value}
                                maxLength={MOBILE_MAX_LENGTH}
                                onBlur={this.handleBlur}
                                onChange={this.handleChange}
                            />
                            <div className="input-group-append">
                                {this.renderFieldStatusIcon(MOBILE_FIELD)}
                            </div>
                        </div>
                        {this.errorMessage(MOBILE_FIELD)}

                        <label htmlFor={NAME_FIELD}>Name</label>
                        <div className="input-group">
                            <input
                                type="text"
                                name={NAME_FIELD}
                                placeholder="Jane Smith"
                                value={fields[NAME_FIELD].value}
                                onBlur={this.handleBlur}
                                onChange={this.handleChange}
                            />
                            <div className="input-group-append">
                                {this.renderFieldStatusIcon(NAME_FIELD)}
                            </div>
                        </div>
                        { this.errorMessage(NAME_FIELD)}

                    </div>
                </div>
                <div className="send-button-container">
                    <button
                        className="btn send-btn"
                        type="submit"
                        aria-label="Send Button"
                        size="lg"
                    >
                        Send
                    </button>
                </div>
                <p className="extra-info">
                    By submitting, you authorize {storeName} and/or GoodBed to
                    send text messages with offers & other information, possibly
                    using automated technology, to the number you provided.
                    Message/data rates apply. Consent is not a condition of
                    purchase.
                </p>
            </>
        );
    }

    renderSuccess() {
        const { storeName } = this.props;
        const { fields } = this.state;

        return (
            <div className="submitted">
                <i className="success-icon fa fa-check-circle-o" />
                <p className="submit-message">
                    Your message was sent to the retailer.
                    <br />
                    {storeName} will text you shortly.
                    <br />
                    <b>Your contact number is: {fields[MOBILE_FIELD].value}</b>.
                </p>
            </div>
        );
    }

    renderError() {
        return (
            <div className="submitted">
                <i className="error-icon fa fa-exclamation-circle" />
                <p className="submit-message">
                    Your message could not be sent.
                    <br />
                    Please, try again:
                </p>

                <button
                    className="btn resend-btn"
                    type="submit"
                    aria-label="Resend Button"
                >
                    Resend the Text
                </button>
            </div>
        );
    }

    renderBody() {
        const { success, submitted } = this.state;

        let body = <div />;

        if (!success && !submitted) body = this.renderForm();
        else if (success && submitted) body = this.renderSuccess();
        else if (!success && submitted) body = this.renderError();

        return <form onSubmit={this.handleSubmit}>{body}</form>;
    }

    renderFooter() {
        return (
            <div
                className="row no-gutters align-items-center justify-content-center"
                style={{ width: "100%" }}
            >
                <div className="links-container">
                    <a href="/siteterms/">Terms of Service</a>{" "}
                    <span className="divider">|</span>{" "}
                    <a href="/privacy/">Privacy Policy</a>
                </div>
            </div>
        );
    }

    render() {
        const { success, submitted } = this.state;
        const { storeSlug } = this.props;

        return (
            <Modal
                id={`${storeSlug}-send-text-modal`}
                className={`send-text-modal ${
                    !success && submitted ? "error show" : ""
                }`}
                header={this.renderHeader()}
                body={this.renderBody()}
                footer={this.renderFooter()}
                centered
                onHide={this.handleCloseModal}
            />
        );
    }
}

SendTextModal.propTypes = {
    retailerID: PropTypes.string.isRequired,
    storeID: PropTypes.string,
    storeSlug: PropTypes.string.isRequired,
    storeName: PropTypes.string.isRequired,
    locationPage: PropTypes.oneOf([
        LDP_METRICS_STORE_LOCATOR_PAGE,
        LDP_METRICS_TRY_THIS_BED_PAGE,
        LDP_METRICS_OTHER_PAGE,
        LDP_METRICS_PROFILE_PAGE,
    ]).isRequired,
    objectClassname: PropTypes.oneOf([
        LDP_METRICS_STORE_CLASSNAME,
        LDP_METRICS_RETAILER_CLASSNAME
    ]),
    isQuickView: PropTypes.bool.isRequired,
    onHide: PropTypes.func,
};

export default SendTextModal;
